<template>
    <div id="detailContainer">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/admin/publishers">??Publishers</router-link></li>
                <li class="breadcrumb-item active">{{ getPublisherName() }}</li>
            </ol>
        </nav>
        <div class="page-header">
            <h3>{{ getPublisherName() }}</h3>
        </div>
        <div class="card">
            <div class="card-body">
                <button class="btn btn-primary" v-on:click="onNewMapClicked();">New Map</button>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../../../../router'
import PublisherService from "@/service/PublisherService";
import MapService from "@/service/MapService";
import Publisher from "@/model/Publisher";
import LangUtils from '@/utils/LangUtils';

const publisherService = new PublisherService();
const mapService = new MapService();

export default {
    data() {
        return {
            publisher: Publisher
        }
    },
    methods: {
        getPublisherName() {
            if (this.publisher && this.publisher.getName) {
                var name = LangUtils.valueForLanguage(this.publisher.getName(), this.$i18n.locale);
                if (name == null || name == "") {
                    name = this.publisher.getId();
                }
                return name;
            } else {
                return "";
            }
        },

        onNewMapClicked() {
            router.push({ path: "/admin/publishers/" + this.publisher.id + "/maps/:newMap"});
        }
    },
    mounted() {
        const publisherId = this.$route.params.publisherId;
        if (publisherId) {
            publisherService.loadPublisher(publisherId).then((publisher) => {
                this.publisher = publisher;

                mapService.loadMapsForPublisher(this.publisher.getId()).then((maps) => {
                    const leftPanelItems = [{
                            id: "title",
                            type: "title",
                            name: this.getPublisherName()
                        }, {
                            id: "banners",
                            type: "link",
                            name: "Banners",
                            url: "/admin/publishers/" + publisher.getId() + "/banners"
                        }, {
                            id: "links",
                            type: "group",
                            name: "??Maps"
                        }];

                    for (const map of maps) {
                        leftPanelItems.push({
                            id: map.getId(),
                            type: "link",
                            url: "/admin/publishers/" + publisher.getId() + "/maps/" + map.getId(),
                            name: LangUtils.valueForLanguage(map.getName(), this.$i18n.locale)
                        });
                    }

                    this.$root.$emit("admin_left_panel_update", { items: leftPanelItems });

                    // this.$root.$emit("admin_left_panel_update", {
                    //     items: [{
                    //         id: "title",
                    //         type: "title",
                    //         name: this.getPublisherName()
                    //     }, {
                    //         id: "links",
                    //         type: "group",
                    //         name: "??Maps"
                    //     }]
                    // });

                    
                }).catch((error) => {
                    // TODO Manage error
                    console.log(error);
                });
            }).catch((error) => {
                //TODO Manage error
                console.log(error);
            });
        }
    }
}
</script>

<style scoped>
#detailContainer {
    margin: 0px;
    width: 100%;
}

.page-header {
    text-align: left;
}

.card {
    text-align: left;
}
</style>